import angular from 'angular'
import email_input from './email_input_with_validation/directive'

angular.module('mmApp.shared.forms', [email_input]);

export default 'mmApp.shared.forms'